import { useMatches } from '@tanstack/react-router'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { NotificationBell } from '@/features/notifications/components/notification-bell'

export function Header() {
  const { t } = useTranslation()
  const matches = useMatches()
  const match = [...matches].reverse().find((m) => m.context?.headerTitleKey)

  return (
    <header className="z-10 flex w-full flex-col border-b border-border bg-card px-6">
      <div className="mx-auto flex w-full max-w-(--breakpoint-xl) items-center justify-between py-12">
        <div className="flex flex-col items-start gap-2">
          <h1 className="text-3xl font-medium text-primary/80">
            {match?.context.headerTitleKey
              ? t(match.context.headerTitleKey as ParseKeys)
              : ''}
          </h1>
          <p className="text-base font-normal text-primary/60">
            {match?.context.headerDescriptionKey
              ? t(match.context.headerDescriptionKey as ParseKeys)
              : ''}
          </p>
        </div>
        <NotificationBell />
      </div>
    </header>
  )
}
